// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC_HmWifAagfwP3qJC4xVFIGAqnIjDZ07Y",
  authDomain: "lucien-df65f.firebaseapp.com",
  projectId: "lucien-df65f",
  storageBucket: "lucien-df65f.firebasestorage.app",
  messagingSenderId: "434244108614",
  appId: "1:434244108614:web:ec6b780f5992a95af3e547"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Helper function to create a dynamic link for an event
export const createEventDynamicLink = async (slug) => {
  try {
    const dynamicLinkDomain = "lucien14.page.link";
    const link = `https://lucien14.web.app/events/${slug}`;

    // This is a placeholder for the actual dynamic link creation
    // In a real implementation, you would use the Firebase Dynamic Links API
    const dynamicLink = `https://${dynamicLinkDomain}/${slug}`;

    return dynamicLink;
  } catch (error) {
    console.error("Error creating dynamic link:", error);
    return null;
  }
};

// Export the services for use in other files
export { app, auth, db, storage };
